import { useEffect, useRef } from 'react'
import { isNativeApp } from '../../../client'
import { useGridBlock, usePage } from '../../../contexts'
import {
  colors,
  imageSrcVerticalBlockAds,
} from '../../../styles/GlobalVariables'
import { mediaCdnReplace, sendGA4 } from '../../../utils'
import { Close } from './icons'
import { usePlayer } from './PlayerContext'
import {
  Overlay,
  OverlayCloseButtonItem,
  OverlayTopButtonsWrap,
} from './Player/PlayerOverlay.style'
import { PlayerViewContainer, PlayerViewWrapper } from './PlayerView.style'
import { AdBlockImage, AdBlockSlideWrap } from './VerticalAdBlockSlide.style'
import { reelsHe } from '../../../locales/reels.he'
import { useModalDialog } from './focusTrap'

interface IVerticalAdBlockSlide {
  onClose: () => void
}

// RESH13-1075: dedicated adblock slide shown instead of the video reel when
// the user opens a vertical player (Timeline / Mini-Series / Mintly) and an
// adblock was detected. No swipe navigation, no video analytics events -
// only the "verticaladblock" event fires, once, when this slide is shown.
export const VerticalAdBlockSlide = ({ onClose }: IVerticalAdBlockSlide) => {
  const pageData = usePage()
  const { gridId } = useGridBlock()
  const { isMiniSeries, isBigBrother, componentType: blockType } = usePlayer()
  const containerRef = useRef<HTMLDivElement>(null)
  const onDialogKeyDown = useModalDialog(containerRef, onClose)

  useEffect(() => {
    const componentType =
      blockType === 'shorts'
        ? 'shorts'
        : isBigBrother
        ? 'bigbrother'
        : isMiniSeries
        ? 'mini_serie'
        : 'mintly'

    sendGA4({
      eventName: isNativeApp() ? 'app_verticaladblock' : 'verticaladblock',
      pageData,
      Component_Type: componentType,
      component_id: gridId,
    })
    // fire once, at the moment the slide is displayed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PlayerViewContainer
      showPlayer
      ref={containerRef}
      role='dialog'
      aria-modal='true'
      aria-label={reelsHe.dialog}
      tabIndex={-1}
      onKeyDown={onDialogKeyDown}
    >
      <PlayerViewWrapper isMiniSeries={isMiniSeries}>
        <AdBlockSlideWrap>
          <AdBlockImage
            src={mediaCdnReplace(imageSrcVerticalBlockAds)}
            alt=''
          />
          <Overlay theme={{}} showNextVideoTip={false}>
            <OverlayTopButtonsWrap>
              <OverlayCloseButtonItem
                type='button'
                aria-label={reelsHe.close}
                onClick={onClose}
                className='close'
              >
                <Close bgColor={colors.darkBlue} bgOpacity={1} />
              </OverlayCloseButtonItem>
            </OverlayTopButtonsWrap>
          </Overlay>
        </AdBlockSlideWrap>
      </PlayerViewWrapper>
    </PlayerViewContainer>
  )
}
